<script setup>
import { storeToRefs } from "pinia";
    import { computed, ref, onMounted, onBeforeMount, onUnmounted } from "vue";
    import LiveKitService from "@/utils/livekit";
    import { useConversationsStore } from "@/stores/conversations";
    import AgentLayout from "@/views/layouts/AgentLayout.vue";
    import PageHeader from "@/components/shared/PageHeader.vue";
    import {
        DxDataGrid,
        DxColumn,
        // DxFilterRow,
        DxHeaderFilter,
        DxToolbar,
        DxItem,
        DxPaging,
        DxPager,
        DxSorting,
        DxScrolling,
        DxColumnChooser,
        DxLoadPanel,
        DxStateStoring,
        DxSearchPanel,
    } from "devextreme-vue/data-grid";
    //   import DxDropDownButton from "devextreme-vue/drop-down-button";
    //   import { default as Button } from "devextreme-vue/button";
    import { exportDataGrid } from "devextreme/excel_exporter";
    import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
    import { Workbook } from "exceljs";
    import saveAs from "file-saver";
    import { jsPDF } from "jspdf";
    import { useRoute } from 'vue-router'
    import { useUiStore } from "@/stores/ui";
    import { useAgentsStore } from "@/stores/agents";
    import { useGridPreferencesStore } from "@/stores/gridPreferences";
import { useCompanyStore } from "@/stores/company";
    const route = useRoute()

    const { companyId } = storeToRefs(useCompanyStore());
    const adminPreferenceId = ref(localStorage.getItem("adminPreferenceId"));
    //   let getModalState = computed(()=> store.getters.getModalState);
    //   import useValidation from '@/utils/helpers/validations';

    //   const { checkLoggedInUserRole } = useValidation();
    const uiStore = useUiStore();
    const agentsStore = useAgentsStore();
    const gridPreferencesStore = useGridPreferencesStore();
    const conversationsStore = useConversationsStore();
    const userDetails = ref(JSON.parse(localStorage.getItem("user")));
    const dataGridRefName = ref(null);
    let showClearAll = ref(false);
    const allowedOperations = ref(["contains"]);
    //   const buttonData = ref(["Excel", "CSV", "PDF"]);
    let testAgentGrid = ref([
        {
            scenario: "Product Price Inquiry",
            query: "How much are the organic avocados?",
            result: "success",
            date: "2023-10-01"
        },
        {
            scenario: "Product Availability Check",
            query: "Do you have whole grain bread in stock?",
            result: "success",
            date: "2023-10-02"
        },
        {
            scenario: "Product Location Request",
            query: "Where can I find the free-range eggs?",
            result: "failed",
            date: "2023-10-03"
        }
    ]);
    //   const state = reactive({
    //     dataCollectionModal: null,
    //   });
    let id = ref(null);
    let agentObj = ref({});
    let senario = ref("");
    let query = ref("");
    const activeTab = ref('console');
    const buttonText = ref("Start");
    const isRecording = ref(false);
    const transcript = ref('');
    let mediaRecorder = null;
    let livekitService = null;
    let audioStream = null;
    let audioContext = null;
    let analyser = null;
    let silenceTimer = null;
    const livekitConnected = ref(false);
    const conversationId = ref(null);
    const LIVEKIT_URL = ref(null);

    const SILENCE_THRESHOLD = 0.01; // Volume threshold (0.0 to 1.0)
    const SILENCE_DURATION = 3000;  // ms of silence before stopping
    //   const dataCollectionModal = (type) => {
    //     if (type == "show") state.dataCollectionModal.show();
    //     else state.dataCollectionModal.hide();
    //   };

    const dataGrid = computed(() => {
      return dataGridRefName.value.instance;
    });

    const contentReady = (e) => {
      let sortedExp = getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
      showClearAll.value = true;
      } else {
      showClearAll.value = false;
      }
      setColumnChooserPosition();
    };

    const getSortedColumns = () => {
      let allColumns = Array.from(Array(dataGrid.value.columnCount()).keys()).map(
      (index) => dataGrid.value.columnOption(index)
      );
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    };

    const setColumnChooserPosition = () => {
      var columnChooserView = dataGrid.value.getView("columnChooserView");
      if (!columnChooserView._popupContainer) {
      columnChooserView._initializePopupContainer();
      columnChooserView.render();
      }
      columnChooserView._popupContainer.option("position", {
      of: dataGrid.value.element(),
      my: "left top",
      at: "left top",
      offset: "0 50",
      });
    };

    const onEditorPreparing = (e) => {
      if (e.parentType == "filterRow") {
      e.editorOptions.placeholder = "Search";
      }
    };

    const clearFilter = () => {
      dataGrid.value.clearFilter("row");
      dataGrid.value.clearFilter("header");
      dataGrid.value.clearFilter("search");
      dataGrid.value.clearSorting();
    };

    const customLoad = async () => {
      await gridPreferencesStore.onTableHeader({url: "/test-agent", companyId : companyId.value
    }).catch(() => {});
      let value = gridPreferencesStore.tableHeaders;
      return value;
    }

    const customSave = (gridState) => {
      gridState.pageIndex = 0;
      gridState.pageSize = 10;
      let value = JSON.stringify(gridState);
      value = value.replace(',"selectedRowKeys":[]', "");

      if (!gridPreferencesStore.tableHeaders) {
      gridPreferencesStore.createTableHeaders({
          url: "/test-agent",
          headers: value,
          filters: "[]",
          companyId : companyId.value,

      }).catch(() => {});
      } else if (value != JSON.stringify(gridPreferencesStore.tableHeaders)) {
      gridPreferencesStore.updateTableHeaders({
          url: "/test-agent",
          headers: value,
          filters: "[]",
          companyId : companyId.value,
          adminPreferenceId : adminPreferenceId.value,
      }).catch(() => {});
      }
    }

    //   const refreshGrid = () => {
    //    //     document.querySelector(".dx-device-desktop").classList.remove('modal-open');
    //     getDataCollectionsGrid();
    //   }

  const onItemClick = (type) => {
    if (type == "Excel") {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Main sheet");
      exportDataGrid({
          component: dataGrid.value,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
      }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
              saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Test History.xlsx"
              );
          });
      });
      // e.cancel = true;
    } else if (type == "CSV") {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Main sheet");
      exportDataGrid({
      component: dataGrid.value,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
      }).then(function () {
          workbook.csv.writeBuffer().then(function (buffer) {
            saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Test History.csv"
            );
          });
      });
    } else if (type == "PDF") {
      const doc = new jsPDF("landscape");
      exportDataGridToPdf({
          jsPDFDocument: doc,
          component: dataGrid.value,
          customizeCell: function(options) {
              const { gridCell, pdfCell } = options;
              if(gridCell.rowType === 'data') {
                // data columns style
                pdfCell.styles = {
                  font: 'times',
                  fontStyle: 'lato',
                  fontSize: 8,
                  cellWidth: 'auto'
                }
              }else{
                // header columns style
                pdfCell.styles = {
                  font: 'times',
                  fontStyle: 'lato',
                  fontSize: 8,
                  fillColor : '#2680EB',
                  textColor : '#FFFFFF',
                  cellWidth: 'auto'
                }
              }
          }
      }).then(() => {
          const pageCount = doc.internal.getNumberOfPages();
          for(let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            const pageSize = doc.internal.pageSize;
            const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
            const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            const header = 'Test History';
            const headerWidth = doc.getTextDimensions(header).w;
            const footer = `Page ${i} of ${pageCount}`;

            // Header
            doc.text(header, (pageWidth - headerWidth) / 2, 10);

            // Footer
            doc.text(footer, pageWidth / 2 - (doc.getTextWidth(footer) / 2), pageHeight - 5, { baseline: 'bottom' });
          }

          doc.save("Test History.pdf");
      });
    }
  }
    const resetStoreData = () =>{
      uiStore.setModalState(false);
      uiStore.setModalData({});
      uiStore.setModalAction(null);
    };

    const getAgentById = () => {
      agentsStore.fetchAgentById({companyId : companyId.value, id : id.value}).then((res) => {
      agentObj.value = res.data;
      }).catch(() => {
      })
    }

    onMounted(() => {
      // dataGrid.value.beginCustomLoading();
    });

    onBeforeMount(async ()=>{
      resetStoreData();
      id.value = await route.params.id;
      testAgentGrid.value = testAgentGrid.value.map( (row) => {
        row.result_text = row.result.charAt(0).toUpperCase() + row.result.slice(1).toLowerCase();
        return row;
      });
      getAgentById();
    })

  const startRecording = async () => {
    if (isRecording.value) {
      stopRecording();
      return;
    }
    transcript.value = '';
    if (!livekitService || !livekitService.isConnected) {
      await setupLiveKit();
    }
    audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorder = new MediaRecorder(audioStream, { mimeType: 'audio/webm' });
    mediaRecorder.ondataavailable = async (event) => {
      if (event.data.size > 0 && livekitService && livekitService.isConnected) {
        await livekitService.sendAudioData(event.data);
      }
    };
    mediaRecorder.start(100);
    isRecording.value = true;
    buttonText.value = 'Stop';
    setupSilenceDetection(audioStream);
  };

  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state !== 'inactive') {
      mediaRecorder.stop();
    }
    if (audioStream) {
      audioStream.getTracks().forEach(track => track.stop());
    }
    isRecording.value = false;
    buttonText.value = 'Start';
    stopSilenceDetection();
  };

function setupSilenceDetection(stream) {
  audioContext = new (window.AudioContext || window.webkitAudioContext)()
  const source = audioContext.createMediaStreamSource(stream)
  analyser = audioContext.createAnalyser()
  analyser.fftSize = 2048
  source.connect(analyser)

  const data = new Uint8Array(analyser.fftSize)
  let silenceStart = null

  const checkVolume = () => {
    analyser.getByteTimeDomainData(data)
    let sum = 0
    for (let i = 0; i < data.length; i++) {
      let val = (data[i] - 128) / 128
      sum += val * val
    }
    const volume = Math.sqrt(sum / data.length)

    if (volume < SILENCE_THRESHOLD) {
      if (!silenceStart) silenceStart = Date.now()
      else if (Date.now() - silenceStart > SILENCE_DURATION) {
        stopRecording()
        return
      }
    } else {
      silenceStart = null
    }

    silenceTimer = requestAnimationFrame(checkVolume)
  }

  checkVolume()
}

function stopSilenceDetection() {
  if (audioContext) {
    audioContext.close()
    audioContext = null
  }
  if (silenceTimer) {
    cancelAnimationFrame(silenceTimer)
    silenceTimer = null
  }
}

const getLiveKitToken = async () => {
  const response = await conversationsStore.getLiveKitToken({
    company_uuid: companyId.value,
    user_uuid: userDetails.value.user.id,
    agent_uuid: agentObj.value.id,
    conversation_uuid: conversationId.value,
  });
  LIVEKIT_URL.value = response.url;
  return response.access_token;
};

const createConversation = async () => {
  const res = await conversationsStore.createConversation({
    companyId: companyId.value,
    user_uuid: userDetails.value.user.id,
    agent_uuid: agentObj.value.id,
  });
  conversationId.value = res.uuid;
};

const setupLiveKit = async () => {
  if (!conversationId.value) {
    await createConversation();
  }
  const token = await getLiveKitToken();
  livekitService = new LiveKitService();
  livekitService.onMessage((response) => {
    if (response.type === 'assistant_text' && response.content) {
      const endIdx = response.content.indexOf('<end>');
      const chunk = endIdx !== -1 ? response.content.substring(0, endIdx) : response.content;
      transcript.value += chunk;
    }
  });
  livekitService.onConnection((isConnected) => {
    livekitConnected.value = isConnected;
  });
  await livekitService.connect(LIVEKIT_URL.value, token);
};

onUnmounted(async () => {
  stopRecording();
  if (livekitService) {
    await livekitService.disconnect();
    livekitService.cleanup();
    livekitService = null;
  }
});
</script>

<template>
  <AgentLayout>      
      <!-- <div class="flex items-center">
        <h4 class="grid-header-title">Data Collection</h4>
        <button :title="checkLoggedInUserRole() ? 'You are not authorized to perform this action!': ''" :disabled="checkLoggedInUserRole()" @click="dataCollectionModal('show')" pill class="grid-header-action-btn">
          Add
        </button>
      </div> -->

      <PageHeader
        :title="agentObj.name"
        subtitle="Test your assistant configuration in a simulated environment."
      />

      <ul class=" mb-40 configurations-tabs" id="myTab" role="tablist">
            <div class="tab-item" :class="{ active: activeTab === 'console' }" @click="activeTab = 'console'" type="button">Console Test</div>
            <div class="tab-item" :class="{ active: activeTab === 'voice' }" @click="activeTab = 'voice'" type="button">Voice Test</div>
      </ul>

      <div class="tab-content ">
        <div v-show="activeTab === 'console'" role="tabpanel" tabindex="0">

          <div class="config-section card mb-10">
            <div class="section-header mb-3">
                <h2>Agent Testing Console</h2>
            </div>
            <div class="section-body mb-10">
                <div class="mb-10  w-full">
                    <DInput :value="senario" @input="senario = $event.target.value" label="E.g., Product inquiry about price" width="100%" />
                </div>
    
                <FloatLabel class="w-full mb-3">
                    <PTextarea v-model="query" id="agentDescription" class="d-textarea resize-none h-105 w-full" autoResize />
                    <label for="agentDescription">User Query</label>
                </FloatLabel>
            </div>
            <div class="section-footer">
                <button type="button" class="btn btn-primary float-end"><i class="bi bi-play"></i>Run Test</button>
            </div>
          </div>
    
          <section class="grid-white-section main-page-container-animation config-section  card">
            <div class="section-header">
              <h2>Test History</h2>
            </div>
            <div class="card-body">
                <DxDataGrid height="100%"
              :data-source="testAgentGrid"
              ref="dataGridRefName"
              :remote-operations="true"
              :showBorders="false"
              :columnAutoWidth="true"
              :allowColumnReordering="true"
              :allowColumnResizing="true"
              :rowAlternationEnabled="false"
              :showColumnLines="false"
              :showRowLines="true"
              :repaint-changes-only="true"
              :two-way-binding-enabled="true"
              :no-data-text="'No history yet'"
              @editor-preparing="onEditorPreparing($event)"
              @content-ready="contentReady($event)"
            >
              <DxLoadPanel :show-indicator="true" :show-pane="true" :enabled="true"/>
              <DxScrolling mode="standard" :use-native="true" />
              <DxPaging :page-size="10" />
              <DxStateStoring :enabled="true" type="custom"  :customSave="customSave" :customLoad="customLoad"/>
    
              <DxPager
                :visible="true"
                :allowed-page-sizes="[10, 25, 50, 100]"
                :display-mode="'full'"
                :show-page-size-selector="true"
                :show-info="true"
                :show-navigation-buttons="true"
              />
    
              <DxSearchPanel :width="200" :visible="true" placeholder="Search ..."/>
              <DxSorting mode="single" />
              <DxHeaderFilter :visible="true" />
              <DxColumnChooser :enabled="true" mode="select" />
    
              <DxToolbar>
                <DxItem location="before" template="columnButtonTemplate" />
                <DxItem location="before" template="exportButtonTemplate" />
                <DxItem location="before" template="clearAllTemplate" />
                <DxItem location="after" name="searchPanel" />
    
              </DxToolbar>
    
                <DxColumn
                    data-field="scenario"
                    caption="Scenario"
                    :allow-header-filtering="false"
                    :filter-operations="allowedOperations"
                    data-type="string"
                    :allow-searching="true"
                />
    
                <DxColumn
                    data-field="query"
                    caption="Query"
                    :allow-header-filtering="false"
                    :filter-operations="allowedOperations"
                    data-type="string"
                    :allow-searching="true"
                />
    
                <DxColumn
                    data-field="result_text"
                    caption="Result"
                    :allow-header-filtering="false"
                    :filter-operations="allowedOperations"
                    data-type="string"
                    :allow-searching="true"
                    cell-template="resultCellTemplate"
                />
    
                <DxColumn
                    data-field="date"
                    caption="Date"
                    :allow-header-filtering="false"
                    :filter-operations="allowedOperations"
                    data-type="string"
                    :allow-searching="true"
                />
    
                <template #resultCellTemplate="{data}">
                    <span class="status-badge" :class="`status-${data.data.result}`">{{ data.value }}</span>
                </template>
    
    
                <template #exportButtonTemplate>
                    <button  @click="onItemClick('Excel')" type="button" class="btn icon-button m-5 font-20"><i class="bi bi-filetype-xlsx"></i> </button>
                </template>
    
                <template #columnButtonTemplate>
                    <button  @click="dataGrid.showColumnChooser()" type="button" class="btn icon-button font-20 m-5"><i class="bi bi-columns"></i> </button>
                </template>
    
                <template #clearAllTemplate>
                    <div v-if="showClearAll" class="clear-cols">
                    <div class="custom-line"></div>
                    <button @click="clearFilter()" type="button" class="btn action-btn clear-colums-filter m-5">Clear Filters </button>
                    </div>
                </template>
              
            </DxDataGrid>
            </div>
            
          </section>
    

        </div>
        <div v-show="activeTab === 'voice'" role="tabpanel" tabindex="0">

          <div class="config-section card mb-10">
            <div class="section-header mb-3">
                <h2>Agent Testing Voice</h2>
            </div>
            <div class="section-body mb-10 flex  items-center justify-center">
              <div class="voice-test-btn-wrapper flex flex-col items-center">
                <button
                  class="voice-circle-btn mb-2"
                  :class="{ 'recording': isRecording }"
                  @click="startRecording"
                  type="button"
                >
                  <i :class="isRecording ? 'bi bi-stop-fill' : 'bi bi-mic'"></i>
                </button>
                <span class="voice-btn-label">{{ buttonText }}</span>
                <p v-if="transcript" class="mt-20 text-center" style="max-width: 480px; color: var(--neutral-700);">{{ transcript }}</p>
              </div>
            </div>
            
          </div>
            
        </div>
      </div>
      

 </AgentLayout>
</template>

<style lang="scss" scoped>

ul{
  padding-left: 0px !important;
}

.date-filter {
  width: 180px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-4);
  margin-bottom: var(--spacing-6);
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
}

.stat-card {
  padding: var(--spacing-4);
  display: flex;
  gap: var(--spacing-4);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: var(--border-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
  
  &.icon-up {
    background-color: var(--success-500);
    color: white;
  }
  
  &.icon-down {
    background-color: var(--error-500);
    color: white;
  }
  
  &.icon-neutral {
    background-color: var(--info-500);
    color: white;
  }
}

.stat-content {
  h3 {
    font-size: var(--text-sm);
    color: var(--neutral-600);
    margin: 0 0 var(--spacing-1) 0;
    font-weight: 500;
  }
}

.stat-value {
  font-size: var(--text-2xl);
  font-weight: 600;
  color: var(--neutral-900);
  margin-bottom: var(--spacing-1);
}

.stat-change {
  font-size: var(--text-xs);
  display: flex;
  align-items: center;
  gap: 2px;
  
  &.trend-up {
    color: var(--success-500);
  }
  
  &.trend-down {
    color: var(--error-500);
  }
}

.charts-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: var(--spacing-4);
  margin-bottom: var(--spacing-6);
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

.chart-container {
  .card-body {
    height: 300px;
  }
}

.details-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-4);
  margin-bottom: var(--spacing-6);
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

.queries-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.query-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: var(--spacing-3);
  border-bottom: 1px solid var(--neutral-100);
  
  &:last-child {
    border-bottom: none;
  }
}

.query-info {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
}

.query-rank {
  width: 24px;
  height: 24px;
  background-color: var(--primary-50);
  color: var(--primary-700);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: var(--text-xs);
}

.query-stats {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
}

.query-count {
  font-weight: 500;
  color: var(--neutral-700);
  min-width: 60px;
  text-align: right;
}

.query-bar {
  width: 120px;
  height: 6px;
  background-color: var(--neutral-100);
  border-radius: 3px;
  overflow: hidden;
  
  .query-bar-fill {
    height: 100%;
    background-color: var(--primary-500);
    border-radius: 3px;
  }
}

.query-percentage {
  min-width: 40px;
  font-size: var(--text-sm);
  color: var(--neutral-600);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  
  th, td {
    padding: var(--spacing-3) var(--spacing-2);
    text-align: left;
    border-bottom: 1px solid var(--neutral-200);
  }
  
  th {
    font-weight: 600;
    color: var(--neutral-700);
  }
  
  tr:last-child td {
    border-bottom: none;
  }
}

.rating-bar {
  width: 160px;
  height: 16px;
  background-color: var(--neutral-100);
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  
  .rating-fill {
    height: 100%;
    background-color: var(--primary-500);
    border-radius: 8px;
  }
  
  .rating-value {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: var(--text-xs);
    font-weight: 600;
    color: white;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }
}

.insights-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-4);
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  .insight-card {
    padding: var(--spacing-4);
    border: 1px solid var(--neutral-200);
    border-radius: var(--border-radius-md);
    display: flex;
    gap: var(--spacing-3);
    width: 500px;
    max-width: 500px;
    &:hover {
      border-color: var(--primary-200);
      background-color: var(--primary-50);
      
      .insight-icon {
        background-color: var(--primary-500);
        color: white;
      }
    }
  }

  .insight-icon {
    width: 40px;
    height: 40px;
    border-radius: var(--border-radius-md);
    background-color: var(--neutral-100);
    color: var(--neutral-600);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.2s ease;
  }

  .insight-content {
    width: 388px;
    h3 {
      margin: 0 0 var(--spacing-1) 0;
      font-size: var(--text-base);
    }
    
    p {
      margin: 0;
      font-size: var(--text-sm);
      color: var(--neutral-600);
    }
  }

  .insight-actions{
    margin-left: auto;
    gap: var(--spacing-2);
  }

}

.voice-test-btn-wrapper {
  align-items: center;
}
.voice-circle-btn {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: none;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: #333;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  transition: box-shadow 0.2s, background 0.2s;
  position: relative;
  outline: none;
  cursor: pointer;
}
.voice-circle-btn.recording {
  background: #e0f7fa;
  box-shadow: 0 0 0 0 rgba(38,128,235, 0.7);
  animation: pulse 1.2s infinite;
  color: var(--primary-color);
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(38,128,235, 0.7);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(38,128,235, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(38,128,235, 0);
  }
}
.voice-btn-label {
  font-size: 1rem;
  color: #333;
  margin-top: 0.25rem;
  text-align: center;
}

</style>